import { render } from "./chess.vue?vue&type=template&id=dddd413c"
import script from "./chess.vue?vue&type=script&lang=js"
export * from "./chess.vue?vue&type=script&lang=js"
script.render = render

export default script